import { render, staticRenderFns } from "./PhoneVerify.vue?vue&type=template&id=0bcf32ba&scoped=true&"
import script from "./PhoneVerify.vue?vue&type=script&lang=js&"
export * from "./PhoneVerify.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerify.vue?vue&type=style&index=0&id=0bcf32ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf32ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDivider,VExpandTransition,VSelect,VTextField})
